import './App.css';
import AppRoutes from '../routes/AppRoutes'
import Navigation from './Navigation/Navigation';


function App() {

  return (

    <>
      <Navigation />
      <AppRoutes />
    </>
  )
}

export default App
